import { render, staticRenderFns } from "./ui-overlay.vue?vue&type=template&id=3a8c0aaa&"
import script from "./ui-overlay.vue?vue&type=script&lang=js&"
export * from "./ui-overlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports